import { useQuery } from '@apollo/client';
import { useParams, useNavigate } from 'react-router';

import { UserInCompanyMutations } from './user_in_company_mutations_container';
import { CompanyUserQuery as CompanyUserQueryResult, CompanyUserQueryVariables } from '../../lib/graphql';
import { Loader } from '../../lib/loader';
import { UserInCompanyView, UserInCompanyViewDataProps } from '../components/user_in_company';
import { companyUserQuery } from '../graphql';

class LoadingContainer extends Loader<
  CompanyUserQueryResult,
  Partial<UserInCompanyViewDataProps>,
  CompanyUserQueryVariables
> {}

export const UserInCompanyContainer = () => {
  const { user_id, company_id } = useParams() as { user_id: string; company_id: string };
  const navigate = useNavigate();
  const isNewUser = user_id === 'new';

  const result = useQuery<CompanyUserQueryResult, CompanyUserQueryVariables>(companyUserQuery, {
    skip: isNewUser,
    variables: { company_id, userId: user_id },
  });

  return (
    <UserInCompanyMutations>
      {({ addUserToCompany, removeUserFromCompany, changeUserRoleInCompany, changeUserMetadataInCompany }) => {
        if (isNewUser) {
          return (
            <UserInCompanyView
              isNewUser={isNewUser}
              addUserToCompany={addUserToCompany}
              changeUserMetadataInCompany={changeUserMetadataInCompany}
              routeProps={{ push: (path: string) => navigate(path), goBack: () => navigate(-1) }}
              company={{ company_id }}
            />
          );
        }

        return (
          <LoadingContainer
            result={result}
            mapData={({ data }) => ({
              data: data.company,
            })}>
            {({ data }) => {
              const userInCompany = data ?? null;
              return (
                <UserInCompanyView
                  isNewUser={false}
                  data={userInCompany}
                  removeUserFromCompany={removeUserFromCompany}
                  changeUserRoleInCompany={changeUserRoleInCompany}
                  changeUserMetadataInCompany={changeUserMetadataInCompany}
                  routeProps={{ push: (path: string) => navigate(path), goBack: () => navigate(-1) }}
                  company={{ company_id }}
                />
              );
            }}
          </LoadingContainer>
        );
      }}
    </UserInCompanyMutations>
  );
};
